import { createSlice } from "@reduxjs/toolkit";

const refundFilterSlice = createSlice({
  name: "refundFilter",
  initialState: {
    status: null,
    search: null,
  },
  reducers: {
    setStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },

    setSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },

    clearSearchFilter: (state) => {
      state.search = null;
    },
  },
});

export const { setStatusFilter, setSearchFilter, clearSearchFilter } =
  refundFilterSlice.actions;

export const selectRefundState = (state) => state.refundFilter;

export default refundFilterSlice.reducer;
